<template>
  <div>
    <web-header :searchStatus="$route.query.moduleId"></web-header>
    <Breadcrumb crumbTitle="公益活动" crumbName="VOLUNTEERING" location="活动 > 活动列表"></Breadcrumb>
    <WtDataList
      v-model="data.list"
      :url="$url.activity.list"
      :pageSize="6"
      :search="search"
      ref="activityRef"
    >
      <div slot="list" ref="list">
        <div class="activity-box">
          <div class="activity-bottom">
            <ul>
              <li v-for="(item,index) in data.list" :key="index" :class="getClass(index)">
                <router-link
                  :to="{ name: 'activityInfo',query: { id: item.id,moduleId:$route.query.moduleId }}"
                >
                  <div class="act-top">
                    <img :src="item.cover_photo_text[0].path" />
                  </div>
                  <template v-if="item.activity_status == 1">
                    <div class="status coming">活动即将开始</div>
                  </template>
                  <template v-else-if="item.activity_status == 3">
                    <div class="status end">活动已结束</div>
                  </template>
                  <template v-else-if="item.activity_status == 2 ">
                    <div class="status ing">活动进行中</div>
                  </template>
                  <div class="act-center">
                    <p>{{getDate(item.activity_start)}}月</p>
                    <h5>{{getDate(item.activity_start,'D')}}日</h5>
                  </div>
                  <div class="act-bottom">
                    <p>{{item.name}}</p>
                    <div class="same_city_Li_dizhiQu">
                      <p
                        class="same_city_Li_address"
                      >{{item.province_text}}{{item.city_text}}{{item.country_text}}</p>
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </WtDataList>
    <WtFooter></WtFooter>
  </div>
</template>
<script>
import webHeader from "../Public/header";
import Breadcrumb from "../Public/breadcrumb";
export default {
  components: {
    webHeader,
    Breadcrumb
  },
  data() {
    return {
      data: {},
      search: {
        type: null
      },
      activityList: [],
      liData: ["liBg1", "liBg2", "liBg3"]
    };
  },
  methods: {
    getDate(date, format = "M") {
      switch (format) {
        case "M": {
          return date.substring(5, 7);
          break;
        }
        case "D": {
          return date.substring(8, 10);
          break;
        }
      }
    },
    getClass(index) {
      let j = parseInt(index);
      if (j % 2 == 0) {
        // 再通过取模来设置每隔3行显示不同的两种颜色
        return "liBg2";
      } else {
        //return "liBg3"
        return "liBg3";
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
#app-activity {
  width: 100%;
  // margin-bottom: 45px;
  background-color: #f5f5f5;
}
.activity-box {
  max-width: 1300px;
  margin: 0 auto;
  padding: 45px 0;
  .activity-top {
    position: relative;
    padding-left: 18px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    > span {
      width: 2px;
      // height: 55px;
      height: 100%;
      background-image: linear-gradient(
          0deg,
          #8ec31f 0%,
          #4eb875 10%,
          #2dbadc 20%,
          #258bcc 31%,
          #273d96 43%,
          #944496 50%,
          #bb4695 53%,
          #dc0536 65%,
          #e83a16 76%,
          #fcd475 89%,
          #d7de00 100%
        ),
        linear-gradient(#c12411, #c12411);
      position: absolute;
      left: 0;
      top: 0;
    }
    .top-l {
      > p {
        font-size: 24px;
        font-weight: normal;
        color: #999999;
      }
      > h3 {
        font-size: 24px;
        font-weight: 500;
        color: #333;
      }
    }
    .top-r {
      padding-right: 25px;
      position: relative;
      width: 308px;
      > ul {
        display: flex;
        justify-content: space-between;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        > li {
          list-style: none;
          margin-right: 30px;
          font-size: 15px;
          font-weight: normal;
          color: #333333;
          padding-bottom: 3px;
          cursor: pointer;
          // &:last-child { // margin-right: 0; // }
          &.active {
            border-bottom: 2px solid #e83a16;
            color: #e83a16;
          }
        }
      }
      > i {
        width: 25px;
        height: 25px;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        background: url(../../assets/images/more.png) no-repeat;
        background-size: 100% 100%;
        &:hover {
          background: url(../../assets/images/more1.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
  .activity-bottom {
    width: 100%;
    > ul {
      flex-wrap: wrap;
      display: flex;
      .liBg1 {
        background-color: #89ba29;
      }
      .liBg2 {
        background-color: #89ba29;
      }
      .liBg3 {
        background-color: #f8b92b;
        .act-center {
          position: absolute;
          width: 75px;
          height: 47px;
          background-color: #ffffff;
          left: 24px;
          top: 175px;
          padding: 14px 0;
          > p {
            font-size: 14px;
            font-weight: normal;
            color: #f8b92b;
            text-align: center;
          }
          > h5 {
            font-size: 24px;
            font-weight: normal;
            color: #f8b92b;
            text-align: center;
          }
        }
      }
      > li {
        list-style: none;
        width: 29%;
        margin: 0px 25px 25px 25px;
        background-color: #89ba29;
        box-shadow: 0px 6px 19px 0px rgba(11, 2, 5, 0.09);
        position: relative;
        cursor: pointer;
        border-radius: 6px;
        overflow: hidden;
        &:hover {
          .act-bottom {
            > p {
              color: #eee;
            }
            > h3 {
              color: #eee;
            }
          }
        }

        .act-top {
          width: 100%;
          > img {
            width: 100%;
            height: 100%;
          }
        }
        .act-center {
          position: absolute;
          width: 75px;
          height: 47px;
          background-color: #ffffff;
          left: 24px;
          top: 175px;
          padding: 14px 0;
          > p {
            font-size: 14px;
            font-weight: normal;
            color: #89ba29;
            text-align: center;
          }
          > h5 {
            font-size: 24px;
            font-weight: normal;
            color: #89ba29;
            text-align: center;
          }
        }
        .act-bottom {
          padding: 63px 34px 28px 24px;
          > p {
            font-size: 16px;
            font-weight: normal;
            color: #ffffff;
            margin-bottom: 18px;
          }
          > h3 {
            font-size: 14px;
            font-weight: normal;
            color: #ffffff;
          }
        }
      }
    }
  }
}
.same_city_Li_dizhiQu {
  width: 100%;
  height: 22px;
  margin-top: 4px;
}
.same_city_Li_time {
  display: inline-block;
  line-height: 20px;
  font-size: 13px;
  color: #fff;
  float: left;
  margin-right: 15px;
}
.same_city_Li_address {
  display: inline-block;
  line-height: 20px;
  font-size: 13px;
  color: #fff;
  float: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
}

.status {
  position: absolute;
  width: 130px;
  right: 0px;
  top: 0px;
  color: #fff;
  font-size: 14px;
  line-height: 36px;
  font-weight: 500;
  text-align: center;
  border-bottom-left-radius: 6px;
}
.status.ing {
  background-color: rgba(255, 111, 2, 0.8);
}
.status.end {
  background-color: #999;
}
.status.coming {
  background-color: #f8b92b;
}
</style>


// WEBPACK FOOTER //
// src/view/Activity/list.vue